/**
 * PublicFormView — a pagina publica do formulario como o visitante ve.
 *
 * Usada de verdade em /f/:slug e, em modo `preview`, dentro da aba Design
 * (mesmo componente, entao o preview nao mente). Recebe os dados publicos
 * do formulario ({nome, descricao, campos, config}) e o `design` — quando
 * omitido, usa `config.design` (o que esta salvo).
 *
 * `viewport="celular"` marca a raiz com data-viewport="mobile": as regras
 * de celular do styles.jsx respondem a esse atributo alem da media query,
 * para o preview estreito dentro do ERP se comportar como um telefone.
 */
import React, { useMemo } from "react";

import FormRenderer from "./FormRenderer";
import { normalizarDesign, varsDoDesign } from "./designConfig";
import {
  PublicBanner,
  PublicCard,
  PublicFooter,
  PublicLogo,
  PublicPage,
  PublicSub,
  PublicTitle,
  PublicTopbar,
} from "./styles";

export default function PublicFormView({
  dados,
  design,
  onSubmit,
  submitting = false,
  readOnly = false,
  preview = false,
  viewport = "desktop",
  previewKey,
  buscarCep,
  uploadArquivo,
}) {
  const config = dados?.config || {};
  const d = useMemo(() => normalizarDesign(design ?? config.design), [design, config.design]);
  const vars = useMemo(() => varsDoDesign(d), [d]);
  const cor = config.tema_cor;
  const titulo = config.titulo_publico || dados?.nome || "";
  const subtitulo = config.subtitulo_publico || dados?.descricao || "";

  return (
    <PublicPage
      $accent={cor}
      $preview={preview}
      style={vars}
      data-viewport={viewport === "celular" ? "mobile" : undefined}
    >
      <PublicTopbar />
      <PublicCard>
        {d.logo_url && (
          <PublicLogo>
            <img src={d.logo_url} alt="" />
          </PublicLogo>
        )}
        {d.imagem_topo_url && (
          <PublicBanner>
            <img src={d.imagem_topo_url} alt="" />
          </PublicBanner>
        )}
        {titulo && <PublicTitle>{titulo}</PublicTitle>}
        {subtitulo && <PublicSub>{subtitulo}</PublicSub>}
        <FormRenderer
          key={previewKey}
          campos={dados?.campos || []}
          config={{ ...config, design: d }}
          themeColor={cor}
          submitLabel={d.botao_texto || "Enviar"}
          submitting={submitting}
          onSubmit={onSubmit}
          readOnly={readOnly}
          buscarCep={buscarCep}
          uploadArquivo={uploadArquivo}
        />
        {d.rodape_texto && <PublicFooter>{d.rodape_texto}</PublicFooter>}
      </PublicCard>
    </PublicPage>
  );
}
